import { useEffect, useState } from 'react';
import { featureBlockedState } from '@/utils/apiClient';

/**
 * Hook that tracks feature-blocked state.
 *
 * Reads the initial state from apiClient's module-level flag (catches
 * events that fired before the component mounted) AND listens for
 * future events.
 */
export function useFeatureBlocked() {
    const [blocked, setBlocked] = useState(featureBlockedState.blocked);
    const [message, setMessage] = useState(featureBlockedState.message);

    useEffect(() => {
        // Check on mount in case the flag was set before this hook mounted
        if (featureBlockedState.blocked) {
            setBlocked(true);
            setMessage(featureBlockedState.message);
        }

        const handler = (e: Event) => {
            const detail = (e as CustomEvent).detail;
            setBlocked(true);
            setMessage(
                detail?.message ||
                    'This feature is not enabled for your organization. Contact support.'
            );
        };

        window.addEventListener('feature-blocked', handler);
        return () => window.removeEventListener('feature-blocked', handler);
    }, []);

    return { blocked, message };
}
